import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React, { ReactNode } from "react";
import { styled } from "../../stitches/stitches.config";

type ColumnWithImageProps = {
  children: ReactNode;
  reverse?: boolean;
  image?: IGatsbyImageData;
  imageAlt?: string;
  className?: string;
};

const ColumnWithImage = ({
  children,
  reverse,
  image,
  imageAlt,
  className,
}: ColumnWithImageProps) => {
  return (
    <Wrapper className={className}>
      <ContentWrapper reverse={reverse}>
        {children}
        {image && (
          <ImageWrapper>
            <GatsbyImage image={image} alt={imageAlt ? imageAlt : ""} />
          </ImageWrapper>
        )}
      </ContentWrapper>
    </Wrapper>
  );
};

export default ColumnWithImage;

const Wrapper = styled("section", {
  backgroundColor: "$offwhite",
    width: "100vw",
    position: "relative",
    marginLeft: "-50vw",
    left: "50%",
   
});

const ContentWrapper = styled("div", {
  display: "flex",
  maxWidth: 1200,
  margin: "auto",
  flexDirection: "column",
  padding: "8px 0px",
  backgroundColor: "$offwhite",
  "@md": {
    paddingTop: "64px 0 64px 0",
    flexDirection: "row",
  },
  variants: {
    reverse: {
      true: {
        "@md": { flexDirection: "row-reverse" },
      },
    },
  },
});

const ImageWrapper = styled("div", {
  padding: 8,
  "@md": {
    padding: 0,
   //: 600,
  },
});
